module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"priority":"Priority","low":"Low","medium":"Medium","high":"High","critical":"Critical"},"fr":{"priority":"Priorité","low":"Basse","medium":"Moyenne","high":"Elevée","critical":"Critique"},"de":{"priority":"Priorität","low":"Niedrig","medium":"Bedeuten","high":"Hoch","critical":"Kritik"}}')
  delete Component.options._Ctor
}
